import { render } from "./ModuleEditor.vue?vue&type=template&id=b674d94e&scoped=true"
import script from "./ModuleEditor.vue?vue&type=script&lang=js"
export * from "./ModuleEditor.vue?vue&type=script&lang=js"

import "./ModuleEditor.vue?vue&type=style&index=0&id=b674d94e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b674d94e"]])

export default __exports__